import { render } from "./GreetingDialog.vue?vue&type=template&id=97819af0&scoped=true"
import script from "./GreetingDialog.vue?vue&type=script&lang=js"
export * from "./GreetingDialog.vue?vue&type=script&lang=js"

import "./GreetingDialog.vue?vue&type=style&index=0&id=97819af0&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97819af0"]])

export default __exports__